import dynamic from "next/dynamic";

export const DynamicContent0802 = dynamic(() => import("./Content0802"), {
  suspense: true,
});
